export const eLetterParamsAR: (Submodule: any) => string[] = submodule => {
  let eLetterParamsArray: string[] = []

  //==================================================================//
  //================DEBTOR & HEADER LEVEL PARAMETERS================//
  //==================================================================//
  const commonDebtorParams: string[] = [
    '[DebtorName]',
    '[DebtorAddress]',
    '[DebtorCompanyRegNo]',
    '[DebtorBankAccName]',
    '[DebtorBankAccNo]',
    '[DebtorSSTRegNo]',
    '[DebtorGSTRegNo]',
    '[DebtorEmail]',
    '[DebtorPhoneNo]',
    '[DebtorMobileNo]',
    '[DebtorTIN]',
    '[DebtorCreditTerm]',
    '[DebtorType]',
    '[DebtorContactName]',
    '[DebtorContactNo]',
    '[DebtorContactEmail]',
    // '[TaxSSTRegNo]',
    // '[TaxGSTRegNo]',
  ]
  const commonHeaderParams: string[] = [
    '[DocumentNo]',
    '[DocumentDate]',
    '[ReferenceNo]',
    '[Description]',
    '[DocRemark]',
    '[CreditTerm]',
    '[Remark]',
  ]
  const einvoiceParams: string[] = [
    '[QRCode]',
    '[EInvoiceValidatedDate]',
    '[EInvoiceSentDate]',
    '[EInvoiceStatus]',
    '[UIN]',
  ]
  const ReceiptParams: string[] = ['[PaymentMethod]', '[ChequeNo]', '[DocAmt]']
  const BankAccountParams: string[] = [
    '[BankAccName]',
    '[BankAccNo]',
    '[BankCode]',
  ]

  //=====================================================//
  //=====================================================//
  //================ITEM LEVEL PARAMETERS================//
  //=====================================================//
  //=====================================================//
  //>>>>> AR INVOICE, CREDIT NOTE & DEBIT NOTE <<<<<//
  const arINVCNDNItemLevelParams: string[] = [
    '[Index]',
    '[BillItemName]',
    '[GLAccountCode]',
    '[GLAccountName]',
    '[ItemRemark]',
    '[TaxRate]',
    '[BaseAmt]',
    '[TaxAmt]',
    '[TotalAmt]',
  ]
  const arCNAllocationLevelParams: string[] = [
    '[AllocIndex]',
    '[AllocDocDate]',
    '[AllocDocNo]',
    '[AllocDesc]',
    '[AllocAmt]',
  ]

  //>>>>> AR PAYMENT & RECEIPT ITEM AND ALLOCATION <<<<<//
  const arPaymentItemLevelParams: string[] = [
    '[Index]',
    '[AllocationDocDate]',
    '[AllocationDocNo]',
    '[AllocationRefNo]',
    '[AllocationDescription]',
    '[AllocationAmt]',
    '[AllocDefaultAmt]',
  ]
  const arPaymentAllocationLevelParams: string[] = [
    '[SubItemIndex]',
    '[AllocatedDetail]',
    '[AllocatedDocAmt]',
  ]

  //>>>>> AR REFUND ALLOCATION <<<<<//
  const arRefundAllocationLevelParams: string[] = [
    '[AllocationDocDate]',
    '[AllocationDocNo]',
    '[AllocationRefNo]',
    '[AllocationRemark]',
    '[AllocationAmt]',
  ]

  //========================================================//
  //================SUMMARY LEVEL PARAMETERS================//
  //========================================================//
  //>>>>> AR INVOICE, CREDIT NOTE & DEBIT NOTE <<<<<//
  const arINVCNDNSummaryParams: string[] = [
    '[SumBaseAmt]',
    '[SumTaxAmt]',
    '[SumTotalAmt]',
  ]

  //>>>>> AR PAYMENT & RECEIPT <<<<<//
  const arPaymentSummaryParams: string[] = [
    '[SumAllocationAmt]',
    '[SumAllocationAmtWord]',
    '[SumUnallocationAmt]',
  ]

  //===============================================//
  //================RETURN FUNCTION================//
  //===============================================//
  switch (submodule) {
    case 'INVOICE':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...arINVCNDNItemLevelParams,
        ...arINVCNDNSummaryParams,
        ...einvoiceParams,
      ])

    case 'CREDIT_NOTE':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...arINVCNDNItemLevelParams,
        ...arCNAllocationLevelParams,
        ...arINVCNDNSummaryParams,
        ...einvoiceParams,
      ])

    case 'DEBIT_NOTE':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...arINVCNDNItemLevelParams,
        ...arINVCNDNSummaryParams,
        ...einvoiceParams,
      ])

    case 'PAYMENT':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...BankAccountParams,
        ...arPaymentItemLevelParams,
        ...arPaymentAllocationLevelParams,
        ...arPaymentSummaryParams,
      ])

    case 'REFUND':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...BankAccountParams,
        ...arRefundAllocationLevelParams,
        ...arPaymentSummaryParams,
      ])
    case 'OFFICIAL_RECEIPT':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...BankAccountParams,
        ...ReceiptParams,
        ...arPaymentSummaryParams,
        ...arPaymentItemLevelParams,
      ])
    case 'ADVANCE':
      return (eLetterParamsArray = [
        ...commonDebtorParams,
        ...commonHeaderParams,
        ...BankAccountParams,
        ...ReceiptParams,
        ...arPaymentSummaryParams,
        ...arPaymentItemLevelParams,
        ...arINVCNDNSummaryParams,
      ])
  }
}
